import { render, staticRenderFns } from "./page-header2.vue?vue&type=template&id=653ebe89&scoped=true&"
import script from "./page-header2.vue?vue&type=script&lang=js&"
export * from "./page-header2.vue?vue&type=script&lang=js&"
import style0 from "./page-header2.vue?vue&type=style&index=0&id=653ebe89&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653ebe89",
  null
  
)

export default component.exports